import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

export interface ProjectsKpiMetricItem {
  id: string;
  label: string;
  value: React.ReactNode;
  help?: React.ReactNode;
}

interface ProjectsKpiMetricGridProps {
  items: ProjectsKpiMetricItem[];
  className?: string;
  onReorder?: (sourceId: string, targetId: string) => void;
}

const ProjectsKpiMetricGrid: React.FC<ProjectsKpiMetricGridProps> = ({ items, className, onReorder }) => {
  const [draggedId, setDraggedId] = useState<string | null>(null);
  const canReorder = typeof onReorder === 'function';

  if (!items.length) return null;

  return (
    <Row className={`projects-kpi-grid g-3 mb-3 ${className || ''}`.trim()}>
      {items.map((item) => (
        <Col
          key={item.id}
          xl={3}
          md={6}
          onDragOver={(event) => {
            if (!canReorder) return;
            event.preventDefault();
          }}
          onDrop={(event) => {
            if (!canReorder) return;
            event.preventDefault();
            const sourceId = draggedId || event.dataTransfer.getData('text/plain');
            setDraggedId(null);
            if (!sourceId || sourceId === item.id) return;
            onReorder(sourceId, item.id);
          }}
        >
          <Card className={`projects-kpi-card dashboard-section-card dashboard-stat-card h-100${draggedId === item.id ? ' is-dragging' : ''}`}>
            <Card.Body>
              <div className="projects-kpi-card-head">
                <div className="projects-kpi-label dashboard-stat-title">{item.label}</div>
                {canReorder && (
                  <div
                    className="projects-kpi-card-handle"
                    title="Arraste para reordenar"
                    draggable
                    onDragStart={(event) => {
                      setDraggedId(item.id);
                      event.dataTransfer.effectAllowed = 'move';
                      event.dataTransfer.setData('text/plain', item.id);
                    }}
                    onDragEnd={() => setDraggedId(null)}
                  >
                    ⋮⋮
                  </div>
                )}
              </div>
              <div className="projects-kpi-value dashboard-stat-value">{item.value}</div>
              {item.help && <div className="projects-kpi-help">{item.help}</div>}
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default ProjectsKpiMetricGrid;
